<template>
  <div>
    <input type="file" @change="previewFile()" /><br />
    <img src="" height="200" alt="Image preview..." />
  </div>
</template>

<script>
export default {
  methods: {
    fileImg(files) {
      let that = this;
      let Orientation;

      console.log(files[0].file, "---->file");

      let file = files[0].file;

      // this.imgPreview(e.target.files[0])
      if (file) {
        EXIF.getData(file, function() {
          // var a = EXIF.pretty(this)
          // alert(a[14])
          Orientation = EXIF.getTag(this, "Orientation");
          console.log(Orientation, "====>Orientation值");
        });
      }

      let reader = new FileReader();

      let img = new Image();

      reader.readAsDataURL(file);

      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      let _this = this;
      reader.onload = ev => {
        // alert("图片转base64:"+reader.result)
        // this.imgBase64 = reader.result
        img.src = ev.target.result;
        img.onload = function() {
          var imgWidth = this.width;
          var imgHeight = this.height;

          console.log(this.width);
          console.log(this.height);
          // alert(this.width)
          // alert(this.height)
          let ratio = imgWidth / imgHeight;
          if (imgWidth > imgHeight && imgWidth > 600) {
            imgWidth = 400;
            imgHeight = Math.ceil(400 / ratio);
          } else if (imgWidth < imgHeight && imgHeight > 900) {
            imgWidth = Math.ceil(200 * ratio);
            imgHeight = 200;
          }

          canvas.width = imgWidth;
          canvas.height = imgHeight;

          if (Orientation && Orientation != 1) {
            switch (Orientation) {
              case 6:
                canvas.width = imgHeight;
                canvas.height = imgWidth;
                ctx.rotate(Math.PI / 2);
                ctx.drawImage(this, 0, -imgHeight, imgWidth, imgHeight);
                break;
              case 3:
                ctx.rotate(Math.PI);
                ctx.drawImage(this, -imgWidth, -imgHeight, imgWidth, imgHeight);
                break;
              case 8: // 旋转-90度
                canvas.width = imgHeight;
                canvas.height = imgWidth;
                ctx.rotate((3 * Math.PI) / 2);
                ctx.drawImage(this, -imgWidth, 0, imgWidth, imgHeight);
                break;
            }
          } else {
            ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
          }
          this.imgBase64 = canvas.toDataURL("image/jpeg", 0.9);
          // this.files[0].url = this.imgBase64 //旋转后的图片
          // console.log(this.imgBase64,"--->base64")
          _this.postInfo.head = this.imgBase64;
          // _this.imgBase64 = this.imgBase64
          _this.showBase64 = true;
          window.aa = this.imgBase64;
          // console.log(window.aa)
          var len = this.imgBase64.length;
          var size = len - (len / 8) * 2;
          console.log(size);
          // alert(size)

          // reader.onload = (ev) => {
          //   // alert("图片转base64:"+reader.result)
          //   this.imgBase64 = reader.result
          //   try {
          //     // localStorage.setItem('imgBase64', reader.result)
          //     window.aa = reader.result
          //   } catch (error) {
          //     // console.log("存储localstorage失败"+error)
          //
          //   }

          // try {
          //   // localStorage.setItem('imgBase64', reader.result)
          //   // window.aa = reader.result
          // } catch (error) {
          //   console.log("存储localstorage失败"+error)
          // }
          // alert('base64全局存储完成')
          // this.$router.push('/result/industry')
          // alert('push完成')
        };
      };
      console.log(this.showBase64);
    },
    previewFile() {
      var preview = document.querySelector("img");
      var file = document.querySelector("input[type=file]").files[0];
      var reader = new FileReader();

      console.log(file, "--->");
      reader.addEventListener(
        "load",
        function() {
          preview.src = reader.result;
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>

<style></style>
